import { Layout, Menu } from "antd";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import SidebarUser from "./components/SidebarUser";
import { useEffect, useState } from "react";
import { fetchCurrentUser } from "../api/user.js";
const { Sider, Content } = Layout;

const items = [{ key: "list", label: "用户管理" }];

export default function UserIndex() {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState(null);
  useEffect(() => {
    fetchCurrentUser().then((res) => {
      setUser(res.data);
      localStorage.setItem("user", JSON.stringify(res.data));
    });
  }, []);
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider width={200}>
        <SidebarUser user={user} />
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[location.pathname]}
          items={items}
          onClick={({ key }) => navigate(key)}
        />
      </Sider>

      <Layout>
        <Content style={{ padding: 16, background: "#f5f5f5" }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}
